import React, { useEffect, useState } from 'react';
import BotoneraFiltros from '../UI/BotoneraFiltros.js';
import CuadroDatos from '../UI/CuadroDatos.js';
import LinkPlus from '../UI/LinkPlus.js';
import Paginador from '../UI/Paginador.js';
import TablaDatos from '../UI/TablaDatos.js';
import * as UI from '../constantes/UI.js';
import { ListaPartidos } from '../constantes/Filtros.js';
import * as TipoEquipo from '../constantes/TipoEquipo.js';
import * as TipoRival from '../constantes/TipoRival.js';
import * as Data from '../data/DataHistoriales.js';
import * as Funciones from '../funciones/FuncionesHistoriales.js';
import * as FuncionesFecha from '../funciones/FuncionesFecha.js';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import styles from './PartidosHistorial.module.css';

const PartidosHistorial = (props) => {
  const tipoHistorial = props.tipoHistorial;
  const competidor = props.competidor;
  const filtrosRival = props.rival;
  const agrupacionRival =
    tipoHistorial === TipoEquipo.CLUB && props.rival?.tipo === TipoRival.CLUB
      ? props.rival?.agrupacionTorneo
      : 0;
  const filtro = agrupacionRival?.id ?? props.filtro ?? ListaPartidos.TOTALES;
  const [partidos, setPartidos] = useState([]);
  const [cantPaginas, setCantPaginas] = useState(null);
  const [pagina, setPagina] = useState(0);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const { esMobile, PARTIDOS_X_PAGINA } = UI.useUI();

  const idCompetidor = competidor?.id;
  const tipoRival = filtrosRival?.tipo;
  const idRival = filtrosRival?.objeto?.id;
  const idCategoria = filtrosRival?.categoria?.id || filtrosRival?.objeto?.categoria?.id;
  const tipoInternacional = filtrosRival?.tipoInternacional?.id;
  const mostrarInternacional = filtrosRival?.tipoInternacional?.id === null;
  const filtroPartidos =
    agrupacionRival === 0
      ? []
      : Funciones.getFiltroPartidos(competidor, tipoHistorial, tipoRival, filtrosRival?.objeto);

  console.log('filtroPartidos:', filtro, filtrosRival, filtroPartidos);
  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    setPagina(0);
    const getTotalPartidos = async () => {
      const pathBase = Data.PathBaseHistorial(tipoHistorial, idCompetidor, tipoRival);
      let total = await Data.GetCantidadPartidos(
        pathBase,
        idRival,
        filtro,
        idCategoria,
        tipoInternacional
      );
      if (total !== null && total !== Promise.resolve(total)) {
        setCantPaginas(Math.floor(total / PARTIDOS_X_PAGINA) + 1);
      }
    };
    if (idCompetidor !== null) {
      getTotalPartidos();
    }
  }, [
    fetchData,
    tipoHistorial,
    idCompetidor,
    filtro,
    tipoRival,
    idRival,
    idCategoria,
    tipoInternacional,
    PARTIDOS_X_PAGINA,
  ]);

  const onFiltroElegido = (filtroElegido) => {
    props.onFiltroElegido(filtroElegido);
  };

  useEffect(() => {
    setPartidos([]);
    if (idCompetidor) {
      const idBusqueda = idRival ? idRival : idCompetidor;
      const path = Data.PathBaseHistorial(tipoHistorial, idCompetidor, tipoRival);
      if (path) {
        const url = Data.URLListaPartidos(
          path,
          idBusqueda,
          filtro,
          pagina,
          PARTIDOS_X_PAGINA,
          idCategoria,
          tipoInternacional
        );
        fetchData(url, setPartidos);
      }
    } else {
      setPartidos([]);
    }
  }, [
    fetchData,
    tipoHistorial,
    idCompetidor,
    filtro,
    tipoRival,
    idRival,
    pagina,
    idCategoria,
    tipoInternacional,
    PARTIDOS_X_PAGINA,
  ]);

  return (
    <CuadroDatos titulo="Partidos" isCargando={isCargando} errores={erroresGetLista}>
      <div className={styles.botoneraFiltros}>
        <BotoneraFiltros
          filtros={filtroPartidos}
          selected={filtro}
          onFiltroElegido={onFiltroElegido}
          onResetPagina={() => setPagina(0)}
        />
      </div>
      <TablaDatos
        estilo={`${styles.tablaPartidos}`}
        lista={partidos}
        isCargando={isCargando}
        textoVacia="No hay partidos cargados"
      >
        <tbody>
          <tr className={`${styles.titulo}`} key="header">
            <td className={`${styles.fecha}`}>{esMobile ? 'Año' : 'Fecha'}</td>
            <td className={`${styles.torneo}`}>Torneo</td>
            <td colSpan="3" className={`${styles.partido}`}>
              Resultado
            </td>
            <td className={`${styles.condicion}`}>{esMobile ? 'C' : 'Cond.'}</td>
            {mostrarInternacional && !esMobile && (
              <td className={`${styles.tipoInternacional}`}>Int.</td>
            )}
          </tr>
          {partidos &&
            partidos.map((partido) => (
              <tr className={`${styles.partidos}`} key={partido.id}>
                <td className={`${styles.fecha}`}>
                  {esMobile
                    ? partido.anioPartido
                    : FuncionesFecha.CamposToFechaCorta(
                        partido.anioPartido,
                        partido.mesPartido,
                        partido.diaPartido
                      )}
                </td>
                <td className={`${styles.torneo}`}>
                  <span className={styles.torneoContenido}>{partido.motivo}</span>
                </td>
                <td className={`${styles.local}`}>{partido.equipoLocal?.nombre}</td>
                <td className={`${styles.resultado}`}>
                  <LinkPlus to={`/partido/${partido.id}`} adaptativo={true}>
                    {partido.resultadoLocal} - {partido.resultadoVisitante}
                  </LinkPlus>
                </td>
                <td className={`${styles.visitante}`}>{partido.equipoVisitante?.nombre}</td>
                <td className={`${styles.condicion}`}>{Funciones.GetCondicion(partido)}</td>
                {mostrarInternacional && !esMobile && (
                  <td className={`${styles.tipoInternacional}`}>
                    {partido.tipoInternacional?.codigo}
                  </td>
                )}
              </tr>
            ))}
        </tbody>
      </TablaDatos>
      {!isCargando && (
        <Paginador
          cantPaginas={cantPaginas}
          cantBotones={5}
          paginaActual={pagina}
          onPaginaElegida={setPagina}
        />
      )}
    </CuadroDatos>
  );
};

export default PartidosHistorial;
